export default "__VITE_ASSET__BX261bAy__"